import { render, staticRenderFns } from "./Makeup.vue?vue&type=template&id=7f6bd66c&scoped=true"
import script from "./Makeup.vue?vue&type=script&lang=js"
export * from "./Makeup.vue?vue&type=script&lang=js"
import style0 from "./Makeup.vue?vue&type=style&index=0&id=7f6bd66c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6bd66c",
  null
  
)

export default component.exports